module.exports = __webpack_public_path__ + "static/img/correct-icon.ce9bbdfb.svg";